<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="turnos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{$t('shifts')}}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li><a class="a-inativo">{{$t($route.meta.contexto)}}</a></li>
                                    <li><a class="a-inativo">{{$t('cadastros')}}</a></li>
                                    <li><a aria-current="page">{{$t('shifts')}}</a></li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button v-if="permissao.create" class="save-btn" type="button" tag="button" @click="$router.push({ name : `${abrev}-turno-new` })">
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>
                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar 
                                :onSearch="debouncedOnSearch" 
                            />
                        </div>
                    </div>
                    <div class="turnos-table registry-wrapper">
                        <empty-table-message
                            v-if="isEmpty"
                            msg="msg-nao-ha-turnos"/>
                        <b-table
                            class="data-table"
                            v-else
                            :data="turnos"
                            @sort="updateSort"
                            backend-sorting backend-pagination>
                                <b-table-column 
                                    v-for="(f, i) in fields"
                                    class="td-center"
                                    :key="i"
                                    :field="f.key"
                                    :label="f.key != 'excluir' ? f.label ? $t(f.label) : $t(f.key) : ''"
                                    :width="f.width"
                                    :class="f.key"
                                    :sortable="f.sortable"
                                    :custom-sort="f.sortFn"
                                    v-slot="props">
                                <div v-if="f.key == 'excluir'">
                                    <b-button 
                                        v-if="permissao.delete"
                                        class="action-button"
                                        :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                        :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                        @click="promptChangeSituacao(props.row)" 
                                        v-tippy 
                                        :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                                    />
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag v-if="props.row[f.key] == 1"
                                        class="table-tag table-tag-full-width" 
                                        type="is-success"
                                        size="is-medium">
                                        {{ $t("ativo") }}
                                    </b-tag>
                                    <b-tag v-else 
                                        class="table-tag table-tag-full-width" 
                                        type="is-danger" 
                                        size="is-medium">
                                        {{$t("inativo") }}
                                    </b-tag>
                                </div>
                                    <div v-else-if="f.key == 'descricao'">
                                        <router-link :to="{
                                            name : `${abrev}-turno-edit`, 
                                            params: { 
                                                id : props.row.id,
                                                descricao: props.row[f.key]
                                            }, 
                                        }">
                                            <pre>{{ props.row[f.key] }}</pre>
                                        </router-link>
                                    </div>
                                    <div v-else-if="f.key == 'criado-em'">
                                        {{ props.row[f.key] | moment('L') }}
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </b-table-column>
                        </b-table>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus.vue';
import TurnoService from "@/services/TurnoService";

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("turno") && !to.name.includes("turno-list")) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
    },
    data() {
        return {
            rotaAninhada: false,
            turnos: [],
            service: new TurnoService(this.$http, this.$router),
            fields: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: "datahorainc", width: null, label: 'criado-em', sortable: true, sortFn: null },
                { key: "situacao", width: 30, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null }
            ],
            isLoading: false,
            isEmpty: false,
            initialLoad: true,
            deleteThis: {},
            debouncedOnSearch: null,
            msgs: [],
            permissao: {},
            sortTable: 'descricao',
            order: 'asc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
            abrev: this.$route.meta.contexto,
            isVenda: this.$route.meta.contexto == "vendas",
            isDespesa: this.$route.meta.contexto == "despesas",
            isPromotor: this.$route.meta.contexto == "promotor",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        if (
            this.$route.name.includes("turno") &&
            !this.$route.name.includes("turno-list")
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        
        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess("vendas", "empresa", "vendas-turno");
        }else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess("agro", "empresa", "agro-turnos");
        }else if (this.isDespesa) {
            this.permissao = this.hasPermissionAccess("despesas", "empresa", "des-turnos");
            this.abrev = this.$route.meta.contexto.slice(0,3);
        }else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess("promotor", "cadastros", "promotor-turnos");
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'shifts' }
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAllVendas(this.sortTable, this.order, currentPage - 1, this.pagination.perPage, this.queryFilter)
                .then(this.mapItems)
                .then(turnos => {
                    this.turnos = turnos;
                    this.isEmpty = this.turnos.length <= 0;
                })
                .catch(e => {
                    console.error('Erro ao carregar Turnos.', e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-carregar-turnos");
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        updateSort(sort, order) {
            this.sortTable = sort;
            this.order = order;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            if (body.content) {
                let clients = body.content.map(c => {
                    const data = this.$moment(new Date(c.datahorainc)).format('DD/MM/YYYY');;
                    return {
                        id: c.idturno,
                        descricao: c.descricao,
                        datahorainc: data,
                        situacao: c.situacao
                    };
                });
                return clients;
            } else {
                return [];
            }
        },
        openModal() {
            this.modalOpen = !this.modalOpen;
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-situacao"
                    : "msg-erro-ao-reativar-situacao";

            let tempSituacao = {
                idturno: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacaoVendas(tempSituacao)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-situacao"
                                : "msg-sucesso-ao-desativar-situacao";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
    }

    .turnos .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .turnos .search-and-filter .search-bar {
        width: 100%;
    }

    .turnos .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
